import { acceptSeedingProposal } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  AcceptSeedingProposalServiceRequest,
  AcceptSeedingProposalServiceResponse,
} from './accept-seeding-proposal.dto';
import {
  AcceptSeedingProposalServiceRequestSchema,
  AcceptSeedingProposalServiceResponseSchema,
} from './accept-seeding-proposal.dto';

export const acceptSeedingProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(AcceptSeedingProposalServiceRequestSchema),
    async (
      request: AcceptSeedingProposalServiceRequest,
    ): Promise<AcceptSeedingProposalServiceResponse> => {
      const apiResponse = await acceptSeedingProposal(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '시딩 제안 수락에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(AcceptSeedingProposalServiceResponseSchema),
  ),
);
